module Meevo.Plugins.Register {

    export class RegisterPaymentPlanService {
        paymentPlanMap: { [id: string]: Model.PaymentPlan; } = {}
        refundPaymentPlanIds: string[] = [];

        constructor(private $rootScope: angular.IRootScopeService,
            private appSettings: Meevo.Components.Common.IAppSettings) {
        }

        updatePaymentPlanPreRecalcuate(registerContext: Meevo.Plugins.Register.RegisterContext, sale: Model.Sale) {
            // Would happen if removing refund lines from the respective refund screens.  If a payment plan
            // reduction line is affected, this will address that
            let originalReductionSaleLines : Model.SaleLine[] = jQuery.extend(true, {}, _(sale.saleLines).where({ saleType: Model.SalesTypeEnum.PaymentPlanReduction }));
            if (registerContext.isRefundMode && !registerContext.switchToPaymentPlanRefund &&
                registerContext.selectedSection.sectionType !== RegisterSectionTypeEnum.PaymentPlan &&
                _(originalReductionSaleLines).any()) {
                registerContext.paymentPlanPaymentsSection.buildRefundLines(sale).then(() => {
                    registerContext.paymentPlanPaymentsSection.applyRefundItems(sale, false, false);
                    //switch to payment plan refund if reduction line has changed
                    for (let reductionSaleLine of sale.saleLines) {
                        let originalReductionSaleLine = _(originalReductionSaleLines).find(saleLine => saleLine.item.id === reductionSaleLine.item.id);
                        if (originalReductionSaleLine && originalReductionSaleLine.finalItemPrice !== reductionSaleLine.finalItemPrice) {
                            registerContext.switchToPaymentPlanRefund = true;
                            break;
                        }
                    }
                });
            }
        }

        updatePaymentPlan(registerContext: Meevo.Plugins.Register.RegisterContext, sale: Model.Sale): void {
            let isPaymentLineStillNeeded = (amount: number, paymentLine: Model.SalePayment): boolean => {
                if (amount <= 0) {
                    sale.paymentLines = _(sale.paymentLines).without(paymentLine);
                    registerContext.modalService.alert("MESSAGE_PAYMENT_PLAN_REMOVED");
                    if (registerContext.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan) {
                        registerContext.selectSection(RegisterSectionTypeEnum.PaymentOptions);
                    }
                    return false;
                }
                return true;
            }
            
            // Update payment plan sale that's being worked on.   Would happen when selecting/unselecting items from ticket
            // while editing payment plan
            if (registerContext.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan &&
                !registerContext.isRefundMode) {
                // reset downpayment so that don't have to worry about down payment now
                // being >= total of selected items when unselecting
                registerContext.paymentPlanPaymentsSection.update(registerContext.paymentPlanPaymentsSection.payment,
                    registerContext.paymentPlanPaymentsSection.paymentPlan, true, true);
            }

            // Update payment plan sale that's not being worked on.   Would happen when changing price for instance.
            else if (!registerContext.isRefundMode) {
                let payment = this.getExistingPaymentPlanPaymentLine(registerContext);
                if (payment) {
                    let amount = payment.amount;
                    let paymentPlanPayment = <PaymentPlanSalePayment>payment;
                    registerContext.paymentPlanPaymentsSection.update(paymentPlanPayment, registerContext.paymentPlan, false);
                    if (payment.amount != amount &&
                        isPaymentLineStillNeeded(payment.amount, payment)) {
                        registerContext.addPayment(payment, false);
                        registerContext.paymentPlan.hasChanged = true;
                    }
                }
            } // Would happen when updating a payment plan refund by modifying salelines on PP refund screen
            else if (!registerContext.switchToPaymentPlanRefund) {
                let paymentPlanSale: Model.Sale;
                if (registerContext.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan) {
                    paymentPlanSale = registerContext.paymentPlanPaymentsSection.sale;
                    // refund is being initially applied from reset of payment plan section
                    if (!paymentPlanSale || !paymentPlanSale.isTemp) {
                        return;
                    }
                    registerContext.paymentPlanPaymentsSection.buildRefundLines(paymentPlanSale, true);
                }
            }
        }

        removePaymentPlanReductionSaleLines(registerContext: RegisterContext, sale: Model.Sale) : boolean {
            let saleLinesToRemove: Model.SaleLine[] = [];
            for (let reductionLine of _(sale.saleLines).
                where({ saleType: Model.SalesTypeEnum.PaymentPlanReduction })) {
                if (reductionLine.finalItemPrice === 0 || !_(sale.saleLines).any((saleLine) => {
                    return saleLine.isRefund && saleLine.paymentPlanId === reductionLine.item.id
                })) {
                    saleLinesToRemove.push(reductionLine);
                }
            }
            if (saleLinesToRemove.length > 0) {
                sale.saleLines = _(sale.saleLines).without(...saleLinesToRemove);
                return true
            }
            return false;
        }

        getExistingPaymentPlanPaymentLine(registerContext: Meevo.Plugins.Register.RegisterContext) {
            return _(registerContext.sale.paymentLines).find((paymentLine: Model.SalePayment) => {
                return paymentLine.paymentCategory === Model.PaymentCategoryEnum.PaymentPlan &&
                    paymentLine.amount > 0
            });
        }

        updateNote(noteText: string,
            registerContext: Meevo.Plugins.Register.RegisterContext) {
            if (registerContext.paymentPlan) {
                registerContext.paymentPlan.note = noteText;
            }
            registerContext.paymentPlanPaymentsSection.paymentPlan.note = noteText;
        }

        finalizePaymentPlanPayment(registerContext: Meevo.Plugins.Register.RegisterContext) {
            return this.validatePaymentPlanRelatedSaleLines(registerContext).then(() => {
                let paymentPlanPaymentLine = this.getExistingPaymentPlanPaymentLine(registerContext);
                if (paymentPlanPaymentLine) {
                    return registerContext.dataService.customMethodData("/api/paymentplan", "post", registerContext.paymentPlan).then(response => {
                        registerContext.paymentPlan.id = response.data.id;
                        (<PaymentPlanSalePayment>paymentPlanPaymentLine).paymentPlanId = response.data.id;
                        for (let saleLine of _(registerContext.sale.saleLines).where({
                            hasPaymentPlan: true,
                            isRefund: false
                        })) {
                            saleLine.paymentPlanId = response.data.id;
                        }
                          
                    });
                }
                else {
                    return registerContext.$q.resolve();
                    }
            })
        }

        validatePaymentPlanRelatedSaleLines(registerContext: Meevo.Plugins.Register.RegisterContext) : ng.IPromise<void> {
            let billPaymentPlans = this.getPaymentPlanIdsForValidation(registerContext.sale, true, false);
            let refundPaymentPlans = this.getPaymentPlanIdsForValidation(registerContext.sale, false, true);

            if (_(Object.keys(billPaymentPlans)).any(billPaymentPlanId => {
                return _(Object.keys(refundPaymentPlans)).indexOf(billPaymentPlanId) !== -1;
            }))
            {
                registerContext.modalService.alert("MESSAGE_CANNOT_PAY_AND_REFUND_PAYMENT_PLAN");
                return registerContext.$q.reject();
            }

            return this.checkPaymentPlanRelatedSaleLines(registerContext, registerContext.sale, true);
        }

        public checkPaymentPlanRelatedSaleLines(registerContext: Meevo.Plugins.Register.RegisterContext, sale: Model.Sale,
            rejectOnFailure: boolean, paymentPlans : Model.PaymentPlan[] = null): ng.IPromise<void> {
            let deferred = registerContext.$q.defer<void>();
            let paymentPlanSaleLineGroups = this.getPaymentPlanIdsForValidation(registerContext.sale, true, true);

            (paymentPlans ? registerContext.$q.resolve(paymentPlans) :
                this.getPaymentPlans(registerContext, Object.keys(paymentPlanSaleLineGroups))).then(paymentPlans => {
                    let saleLineIndicesToRemove: number[] = []
                    let transactionIds: string[] = [];
                    for (const paymentPlanId of Object.keys(paymentPlanSaleLineGroups)) {
                        let paymentPlan = _(paymentPlans).findWhere({ id: paymentPlanId });
                        let paymentPlanSaleLineGroup = paymentPlanSaleLineGroups[paymentPlanId];
                        let paymentPlanSaleLine = sale.saleLines[paymentPlanSaleLineGroup.saleLineIndices[0]];

                        if (paymentPlan.entityVersion !== paymentPlanSaleLine.item.paymentPlanEntityVersion ||
                            paymentPlan.hasPendingBill) {
                            if (paymentPlan.entityVersion !== paymentPlanSaleLine.item.paymentPlanEntityVersion &&
                                paymentPlanSaleLine.isRefund) {
                                delete this.paymentPlanMap[paymentPlan.id];
                            }
                            saleLineIndicesToRemove.push(...paymentPlanSaleLineGroup.saleLineIndices);
                            transactionIds.push(paymentPlanSaleLine.isRefund ? paymentPlanSaleLine.refundTransactionId : 
                                (<PaymentPlanPaymentSaleLineItem>paymentPlanSaleLine.item).saleTransactionId);
                        }
                    }
                    if (saleLineIndicesToRemove.length === 0) {
                        deferred.resolve();
                        return;
                    }
                    let orderedSaleLineIndicesToRemove = _(saleLineIndicesToRemove).sortBy(index => {
                        return index;
                    });
                    for (let i = orderedSaleLineIndicesToRemove.length - 1; i >= 0; i--) {
                        sale.saleLines.splice(orderedSaleLineIndicesToRemove[i], 1);
                    }

                    let messages = [];
                    if (transactionIds.length === 1) {
                        messages.push(registerContext.$translate.instant("MESSAGE_STALE_PAYMENT_PLAN_RELATED_SALE_LINE_REMOVE",
                            {
                                saleTransactionId: transactionIds[0]
                            }));
                    }
                    else {
                        messages.push(registerContext.$translate.instant("MESSAGE_STALE_PAYMENT_PLAN_RELATED_SALE_LINES_REMOVE"));
                        messages.push("<ul>");
                        for (let transactionId of transactionIds) {
                            messages.push(`<li>${transactionId}</li>`);
                        }
                        messages.push("</ul>");
                    }

                    if (this.removePaymentPlanReductionSaleLines(registerContext, sale)) {
                        registerContext.recalculateSale();
                    }
                    
                    registerContext.modalService.alert(messages.join(''), Components.Modal.ModalTranslationModes.AsHtml).then(() => {
                        rejectOnFailure ? deferred.reject() : deferred.resolve();
                    })
            })
            return deferred.promise;
        }

        showPaymentPaymentPlanTicketView(registerContext: Meevo.Plugins.Register.RegisterContext) : boolean {
            return !registerContext.isRefundMode
                && registerContext.selectedSection
                && registerContext.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan;
        }

        canBeAddedToPaymentPlan(saleLine: Model.SaleLine): boolean {
            switch (saleLine.saleType) {
                case Model.SalesTypeEnum.Service:
                case Model.SalesTypeEnum.Product:
                case Model.SalesTypeEnum.Package:
                case Model.SalesTypeEnum.TicketCharge:
                    break;
                default:
                    return false;
            }

            return saleLine.finalItemPriceCharge > 0 && !saleLine.packageRedeemed;
        }

        isPaymentPlanPaymentSaleLineRemovable(sale: Model.Sale, saleLine: Model.SaleLine) {
            let paymentPlanId = (<PaymentPlanPaymentSaleLineItem>saleLine.item).id;
            let billSaleLines = sale.saleLines.filter((saleLine: Model.SaleLine) => {
                return saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPayment &&
                    (<PaymentPlanPaymentSaleLineItem>saleLine.item).id === paymentPlanId;
            });
            let orderedBills = _(billSaleLines).sortBy((billSaleLine: Model.SaleLine) => {
                return (<PaymentPlanPaymentSaleLineItem>billSaleLine.item).paymentDate;
            });
            return _(orderedBills).last() === saleLine;
        }

        public getPaymentPlanIdsForValidation(sale: Model.Sale, includePaymentSaleLines: boolean, includeRefundSaleLines: boolean) {
            let paymentPlans = {};
            for (let index = 0; index < sale.saleLines.length; index++) {
                const saleLine = sale.saleLines[index];
                if (includePaymentSaleLines && saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPayment) {
                    let paymentPlanPaymentItem = <PaymentPlanPaymentSaleLineItem>saleLine.item;
                    if (paymentPlans[paymentPlanPaymentItem.id]) {
                        paymentPlans[paymentPlanPaymentItem.id].saleLineIndices.push(index);
                    }
                    else {
                        paymentPlans[paymentPlanPaymentItem.id] = {
                            saleLineIndices: [index]
                        }
                    }
                }
                else if (includeRefundSaleLines && saleLine.isRefund && !_(saleLine.paymentPlanId).isEmpty()) {
                    if (paymentPlans[saleLine.paymentPlanId]) {
                        paymentPlans[saleLine.paymentPlanId].saleLineIndices.push(index);
                    }
                    else {
                        paymentPlans[saleLine.paymentPlanId] = {
                            saleLineIndices: [index]
                        }
                    }
                }
            }
            return paymentPlans;
        }

        public getPaymentPlans(registerContext: Meevo.Plugins.Register.RegisterContext,
            ...paymentPlanIds: string[][]) : ng.IPromise<Model.PaymentPlan[]> {

            let finalPaymentPlanIds: string[] = [];
            for (let i = 0; i < paymentPlanIds.length; i++) {
                finalPaymentPlanIds.push(...paymentPlanIds[i]);
            }

            //make unique
            finalPaymentPlanIds = finalPaymentPlanIds.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            let promises: any[] = [];
            for (const paymentPlanId of finalPaymentPlanIds) {
                promises.push(this.getPaymentPlan(paymentPlanId, registerContext));
            }

            return registerContext.$q.all(promises);
        }

        getPaymentPlan(id: string, registerContext: RegisterContext): ng.IPromise<Model.PaymentPlan> {
            return registerContext.dataService.getItem<Model.PaymentPlan>("paymentPlan", new Guid(id)).then((paymentPlan: Model.PaymentPlan) => {
                return paymentPlan;
            });
        }

        goToPaymentPlanManager(paymentPlanId: string) {
            let targetRoute = `${this.appSettings.ROUTE_NAMES.paymentPlans}/${paymentPlanId}/main`;

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.paymentPlans,
                stateParams: {
                    targetRoute
                }
            });
        }

        checkRefundPaymentPlanIds(registerContext: RegisterContext, sale: Model.Sale): ng.IPromise<void> {
            let deferred = registerContext.$q.defer<void>();
            if (_(this.refundPaymentPlanIds).any()) {
                registerContext.paymentPlanPaymentsSection.getPaymentPlansForRefund(this.refundPaymentPlanIds, sale).then((paymentPlans) => {
                    if (_(paymentPlans).any(paymentPlan => {
                        return paymentPlan.remainingBalance > 0;
                    })) {
                        registerContext.switchToPaymentPlanRefund = true;
                    }
                    deferred.resolve();
                }).finally(() => {
                    this.refundPaymentPlanIds = [];
                })
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        paymentPlanHasRemainingBalance(paymentPlanId: string): boolean {
            return !_(this.paymentPlanMap[paymentPlanId]).isEmpty() && this.paymentPlanMap[paymentPlanId].remainingBalance > 0;
        }

        static factory(): Function {
            let svc = (
                $rootScope,
                appSettings
            ) => new RegisterPaymentPlanService(
                $rootScope,
                appSettings);

            svc.$inject = ["$rootScope", "meevo.AppSettings"];

            return svc;
        }
    }

    angular.module("meevo.plugins.register")
        .service("meevo.plugins.register.RegisterPaymentPlanService", RegisterPaymentPlanService.factory());
}